import { render, staticRenderFns } from "./FooterEze.vue?vue&type=template&id=55128e8d&"
import script from "./FooterEze.vue?vue&type=script&lang=js&"
export * from "./FooterEze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports